import React, { Fragment, useEffect, useState, useContext } from "react";
import localization from "../../../assets/localization/localization";
import Layout from "../../../components/sales/layout/layout";
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import DivLayout from "../../../components/sales/divLayout/divLayout";
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import ModalPop from "components/sales/modal/modal";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import { Button } from "react-bootstrap";
import Images from 'assets/images/imageData';
import moment from "moment/moment";
import {toast } from "react-toastify";
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import TableSection from "components/sales/tableSection/tableSection";

const ValetChartListView = ({
    match,
    getAllValetRaisedTickets,
    allRaisedTicketsList = [],
    documentUrlDataPublic,
    documentUploadUrlPublic,
    getValetOpsRespond,
    getResponseFromValetOps = [],
    updateStatusValetHead,
    statusUpdate = []
}) => {

    const inputs = {
        message_id: match?.params?.message_id,
        message: '',
        media_url: []
      };
      const [formData, setFormData] = useState(inputs);
      const [isLoading, setIsLoading] = useState(false);
      const[isModal, setIsModal] = useState(false);
      const [roleId,setRoleId] = useState('');
      const [approveModal, setApproveModal] = useState(false);
      const [rejectModal, setRejectModal] = useState(false);
      const { baseUrl } = useContext(BaseUrl);
      const [listData, setListData] = useState([]);

    const Headers = [
        "Role",
        "Message",
        "Status",
        "Time",
        "Media",
        "",
    ];

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getAllValetRaisedTickets(1, null, match?.params?.message_id);
            setIsLoading(false);
        })();
    }, []);

    const handleOpsSubmit = async () => {
        if(formData.message === '') {
            toast.error('Please enter message!')
            return false;
        }
        // if(formData.media_url === '') {
        //     toast.error('Please upload media!');
        //     return false;
        // }
        setIsLoading(true);
        const res = await getValetOpsRespond(formData);
        if(res.status){
            setIsModal(true);
        }
        setIsLoading(false);
    }

    const handleHeadResponse = async (headStatus) => {
        const payload = {
            message_id: match?.params?.message_id,
            status: headStatus,
        };
        // console.log('payload check:', payload);
        // return false;
        setIsLoading(true);
        const res = await updateStatusValetHead(payload);
        if(res.status){
            setIsModal(true);
        }
        setIsLoading(false);
    }
    

    const handleModalHide = () => setIsModal(false);

    useEffect(() => {
        setTimeout(() => {
          setIsLoading(true);
          (async () => {
            if(localStorage.getItem('roles')){
              const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
              setRoleId(roles);
            }
           
          })();
          setIsLoading(false);
        }, 1000);
      }, []); 
      
      const handleMediaUrlFiles = (url) => {
        // console.log('url test:', url);
        // return false;
        window.open(url, '_blank');
      };
      
      
      
      useEffect(() => {
        const tableData = [
            'id',
            'role',
            'message',
            'status',
            'time',
            'media_url',
            ''
        ];
    
        if (allRaisedTicketsList && allRaisedTicketsList?.resultSets?.data[0]?.support_messages) {
            const data = allRaisedTicketsList?.resultSets?.data[0]?.support_messages.map((element) =>
                Object.fromEntries(
                    tableData.map((key) => [
                        key,
                        key === 'media_url' ? element['media_url'] : element[key]
                    ])
                )
            );
            setListData(data);
        } else {
            setListData([]);
        }
    }, [allRaisedTicketsList]);
    

    const handleApproveButton = async () => {
        setIsLoading(true);
        setApproveModal(true);
        setIsLoading(false);
    }

    const handleRejectButton = async () => {
        setIsLoading(true);
        setRejectModal(true);
        setIsLoading(false);
    }

    const handleApproveModalHide = () => setApproveModal(false);
    const handleRejectModalHide = () => setRejectModal(false);

    const headerBtns = () => {
        return (
            <Fragment>
            {roleId === 47 && allRaisedTicketsList?.resultSets?.data[0]?.status === "RESPONDED" && (
                <>
                <Button
                    onClick={ () => handleApproveButton()}
                    className="btn btn-success"
                >
                    {'Approve'}
                </Button>
                <Button
                    onClick={ () => handleRejectButton()}
                    className="btn btn-danger"
                >
                    {'Reject'}
                </Button>
                </>
            )}
            </Fragment>
        );
    };

    console.log("fgdsatftydasgjh:", allRaisedTicketsList)

    return (
        <>
            <Layout 
                title={'Detailed View'} 
                isLoading={isLoading} 
                isGoback={true}
                Buttons={headerBtns}
            >
                <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">{localization.detailView}</div>
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                            <DivLayout 
                                heading={"User Name"} 
                                data={allRaisedTicketsList?.resultSets?.data[0]?.user_name} 
                            />
                            <DivLayout 
                                heading={"Phone Number"} 
                                data={allRaisedTicketsList?.resultSets?.data[0]?.user_phone_number} 
                            />
                            <DivLayout
                                heading={"Role"}
                                data={allRaisedTicketsList?.resultSets?.data[0]?.role}
                            />
                            <DivLayout 
                                heading={"Status"} 
                                data={allRaisedTicketsList?.resultSets?.data[0]?.status} 
                                className
                            />
                            <DivLayout
                                heading={"Created At"} 
                                data={moment(allRaisedTicketsList?.resultSets?.data[0]?.created_at).format("DD-MM-YYYY, HH:mm")}
                            />
                            <DivLayout
                                heading={"Updated At"}
                                data={moment(allRaisedTicketsList?.resultSets?.data[0]?.updated_at).format("DD-MM-YYYY, HH:mm")}
                            />
                        </div>
                    </div>
                </div>

                <div  className="panel-card card-details" width="100%">
                    <div className="panel-body">
                        <div className="details-listing detail_alignment">
                                <TableSection
                                    data={listData}
                                    headers={Headers}
                                    isId={false}
                                    handleMediaUrlFiles={handleMediaUrlFiles}
                                />
                        </div>
                    </div>
                </div>

                {roleId === 26 && (allRaisedTicketsList?.resultSets?.data[0]?.status === "OPEN" || allRaisedTicketsList?.resultSets?.data[0]?.status === "REOPENED") && (
                    <div className="panel-card card-details" width="100%">
                    <div className="panel-heading">{localization.leveloneDetails}</div>
                    <div className="panel-body">
                        <div className='row' >
                            <div className="col-md-8">
                                <TextAreaInput
                                    inputValue={formData?.message !== null ? formData?.message : ''}
                                    className={`${!formData.message && 'empty'} inline-css scrollbar-styling`}
                                    rows={4}
                                    type="text"
                                    label={localization.message}
                                    required
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    handleChange={(e) => setFormData({ ...formData, message: e.target.value })}
                                />
                            </div>
                            <div className="col-md-4">
                                <FileUpload
                                    id="addAttachment"
                                    accept=".pdf,.png,.jpg,.jpeg,.doc,.mp3"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) =>
                                        setFormData({ ...formData, media_url: val })
                                    }
                                >
                                <span className="btn btn-transparent">
                                    {'Media'}
                                    {/* <span style={{color:'red'}}>*</span> */}
                                </span>
                                </FileUpload>
                            </div>
                        </div>

                        <div className="col-md-12 mb-4">
                            <div className="col-md-8">
                                <button
                                    className="btn btn-primary"
                                    onClick={(e) => handleOpsSubmit(e)}
                                    type="button"
                                    >
                                    {localization.submit}
                                </button>
                            </div>
                            
                        </div>
                    </div>
                </div>
                )}

                {/* {allRaisedTicketsList?.data?.data[0]?.support_response.map((message, index) => (
                    <div key={index} className="panel-card card-details" width="100%">
                        <div className="panel-heading">{'Support Response: ' + (index + 1)}</div>
                        <div className="panel-body">
                            <div className="details-listing detail_alignment">
                                <DivLayout 
                                    heading={"Role"} 
                                    data={message.role} 
                                />
                                <DivLayout 
                                    heading={"Status"} 
                                    data={message.status} 
                                />
                                <DivLayout
                                    heading={"Message"}
                                    data={message.message}
                                />
                                <DivLayout
                                    heading={"Time"} 
                                    data={moment(message.time).format("DD-MM-YYYY, HH:mm")}
                                />
                                <DocumentView
                                    title={"Media URL"}
                                    attachment={message.media_url[0]} 
                                />
                            </div>
                        </div>
                    </div>
                ))} */}

                <ModalPop
                    title={localization.conf}
                    show={isModal}
                    handleModalHide={handleModalHide}
                    keyboard
                    backdrop
                >
                    <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>{'Respond Successfull'}</h5>
                    {/* <Button
                        onClick={handleModalHide}
                        className="btn btn-primary mb-4"
                    >
                        {localization.goToMeetingList}{' '}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button> */}
                    <Link
                        to={`${baseUrl}/valet-chat-list`}
                        className="btn btn-primary mb-4"
                    >
                        {'Back to list'}{' '}
                        <img src={Images?.ArrowRight} alt="" />
                    </Link>
                    </div>
                </ModalPop>

                
                <ModalPop
                    title={localization.conf}
                    show={approveModal}
                    handleModalHide={handleApproveModalHide}
                    keyboard
                    backdrop
                >
                    <div className="text-center">
                        <div className="success">
                            <img src={Images?.tick} alt="" />
                        </div>
                        <h5>{'Are you sure to approve?'}</h5>
                        <div style={{display:'flex', justifyContent:'space-evenly'}}>
                                <Button
                                    onClick={handleApproveModalHide}
                                    className="btn btn-primary mb-4"
                                >
                                    {localization.no}
                                </Button>
                                <Button
                                    onClick={ () => handleHeadResponse("CLOSED")}
                                    className="btn btn-primary mb-4"
                                >
                                    {localization.yes}
                                </Button>
                        </div>
                    </div>
                </ModalPop>

                <ModalPop
                    title={localization.conf}
                    show={rejectModal}
                    handleModalHide={handleRejectModalHide}
                    keyboard
                    backdrop
                >
                    <div className="text-center">
                        <div className="success">
                            <img src={Images?.tick} alt="" />
                        </div>
                        <h5>{'Are you sure to reject?'}</h5>
                        <div style={{display:'flex', justifyContent:'space-evenly'}}>
                                <Button
                                    onClick={handleRejectModalHide}
                                    className="btn btn-primary mb-4"
                                >
                                    {localization.no}
                                </Button>
                                <Button
                                    onClick={ () => handleHeadResponse("REOPENED")}
                                    className="btn btn-primary mb-4"
                                >
                                    {localization.yes}
                                </Button>
                        </div>
                    </div>
                </ModalPop>
            </Layout>
        </>
    );
};

export default ValetChartListView;

